import {
  useCreateCommentMutation,
  useCreatePostMutation,
  useDeleteCommentMutation,
  useDeletePostMutation,
  useUpdateCommentMutation,
  useUpdatePostMutation,
} from 'redux-store/api/activity-feed';
import { DraftType } from '../useDrafts/types';
import { DraftHandlerMap } from './types';

export const useDraftHandlers = <T extends DraftType>(type: T): DraftHandlerMap[T] => {
  const [createPost, createPostResult] = useCreatePostMutation();
  const [updatePost, updatePostResult] = useUpdatePostMutation();
  const [deletePost, deletePostResult] = useDeletePostMutation();

  const [createComment, createCommentResult] = useCreateCommentMutation();
  const [updateComment, updateCommentResult] = useUpdateCommentMutation();
  const [deleteComment, deleteCommentResult] = useDeleteCommentMutation();

  const handlersMap: DraftHandlerMap = {
    POST: {
      CREATE_POST: createPost,
      UPDATE_POST: updatePost,
      DELETE_POST: deletePost,
      results: {
        isLoading:
          createPostResult.isLoading || updatePostResult.isLoading || deletePostResult.isLoading,
      },
    },
    COMMENT: {
      CREATE_COMMENT: createComment,
      UPDATE_COMMENT: updateComment,
      DELETE_COMMENT: deleteComment,
      results: {
        isLoading:
          createCommentResult.isLoading ||
          updateCommentResult.isLoading ||
          deleteCommentResult.isLoading,
      },
    },
  };

  return handlersMap[type];
};
